export default __webpack_public_path__ + "static/media/B0001.e57a09eb.png";